























import { computed, defineComponent } from '@nuxtjs/composition-api';
import { SfImage } from '@storefront-ui/vue';
import SvgImage from '~/components/General/SvgImage.vue';
import { useConfig } from '~/composables';

export default defineComponent({
  name: 'HeaderLogo',
  components: { SvgImage, SfImage },
  setup() {
    const { config } = useConfig();

    const logoSrc = computed(() => {
      const baseMediaUrl = config.value.base_media_url;
      const logo = config.value.header_logo_src;

      return baseMediaUrl && logo ? `${baseMediaUrl}logo/${logo}` : '';
    });

    const logoWidth = computed(() => config.value.logo_width || '215');

    const logoHeight = computed(() => config.value.logo_height || '32');

    const logoAlt = computed(() => config.value.logo_alt || 'Logo');

    return {
      logoAlt,
      logoHeight,
      logoSrc,
      logoWidth,
    };
  },
});
